import { NomenclatureItem, NomenclatureItemCreate } from '../bus/nomenclature/types';
import $axios from '../utils/axios-instance';

export default class NomenclaturesApi {
  async getNomenclatureList() {
    return await $axios
      .get<{ data: NomenclatureItem[] }>('/v1/Nomenclature')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getNomenclatureDetail(data: { id: number | string }) {
    return await $axios
      .get<NomenclatureItem>(`/v1/Nomenclature/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createNomenclature(data: Omit<NomenclatureItemCreate, 'id'>) {
    return await $axios
      .post('/v1/Nomenclature', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeNomenclature(data: NomenclatureItem) {
    return await $axios
      .put(`/v1/Nomenclature/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteNomenclature(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Nomenclature/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
